import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

const guideConfig = {
  operator: {
    title: '运营商管理',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索运营商',
          description: '按名称或状态搜索运营商，快速定位需要管理的运营商',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '操作按钮',
          description: '点击"新增"创建运营商，"批量删除"可一次删除多个',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '运营商列表',
          description: '展示所有运营商信息，包括绑定的系统用户、联系方式和状态',
          position: 'top'
        }
      }
    ]
  },
  station: {
    title: '充电站管理',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索站点',
          description: '按站点名称或所属运营商搜索，管理员可切换运营商筛选',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '常用操作',
          description: '新增：手动创建站点\n导入：批量导入站点（Excel格式）\n导入模板：下载标准模板，按模板填写后导入\n导出：导出站点数据为Excel',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '站点列表',
          description: '展示所有站点信息，可查看推送状态和推送记录。"编辑"可修改站点信息，"删除"会先通知监管平台再删除',
          position: 'top'
        }
      },
      {
        element: '.el-pagination',
        popover: {
          title: '分页控制',
          description: '切换每页显示数量和页码，数据多时可选择每页50或100条',
          position: 'top'
        }
      }
    ]
  },
  equipment: {
    title: '充电设备管理',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索设备',
          description: '按充电桩编码搜索，管理员可按运营商筛选',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '操作按钮',
          description: '新增：手动添加设备\n设备导入：批量导入设备，自动匹配或创建站点\n端口导入：批量导入端口\n模板下载：可选择设备模板或端口模板\n导出：导出设备数据\n批量推送：选中多个设备一起推送到监管平台',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '设备列表',
          description: '展示设备信息、在线状态和推送状态。\n点击"端口管理"可管理该设备下的充电端口',
          position: 'top'
        }
      },
      {
        element: '.el-pagination',
        popover: {
          title: '分页控制',
          description: '切换每页显示数量和翻页',
          position: 'top'
        }
      }
    ]
  },
  order: {
    title: '充电订单管理',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索订单',
          description: '按订单编号、手机号或运营商搜索订单',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '操作按钮',
          description: '新增：手动创建订单\nExcel导入：从Excel文件批量导入订单\nCSV导入：从中联投平台导出的CSV文件导入（自动识别编码）\n下载模板：获取标准导入模板\n导出：导出订单数据\n批量推送：选中订单一起推送',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '订单列表',
          description: '展示订单详情、充电状态和推送状态。\n"充电中"订单推送给监管平台表示开始充电，"已结束"订单推送表示结束充电\n点击"推送记录"可查看推送历史和失败原因',
          position: 'top'
        }
      },
      {
        element: '.el-pagination',
        popover: {
          title: '分页控制',
          description: '切换每页显示数量和翻页',
          position: 'top'
        }
      }
    ]
  },
  alarm: {
    title: '充电预警',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索预警',
          description: '按订单编号、充电桩编号或手机号搜索预警记录',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '操作按钮',
          description: '批量推送：选中多条预警一起推送\n导入：从Excel批量导入预警记录\n下载导入模板：获取标准导入模板',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '预警列表',
          description: '展示预警类型、内容、时间和推送状态。\n推送状态说明：灰色=未推送，绿色=已推送，红色=推送失败\n点击"推送记录"可查看详情并重试失败的推送',
          position: 'top'
        }
      }
    ]
  },
  report: {
    title: '充电过程上报',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '搜索上报记录',
          description: '按订单编号或手机号搜索充电过程上报记录',
          position: 'bottom'
        }
      },
      {
        element: '.action-card',
        popover: {
          title: '批量推送',
          description: '选中多条上报记录一起推送到监管平台',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '上报记录列表',
          description: '展示充电过程中的实时功率和上报时间。\n每条记录可单独推送或查看推送记录',
          position: 'top'
        }
      }
    ]
  },
  push: {
    title: '推送日志',
    steps: [
      {
        element: '.search-card',
        popover: {
          title: '筛选日志',
          description: '按数据类型（站点/设备/端口/订单/上报/告警）、业务编号或推送状态筛选',
          position: 'bottom'
        }
      },
      {
        element: '.el-table',
        popover: {
          title: '推送日志列表',
          description: '展示所有推送记录的状态和时间。\n点击"详情"可查看完整的请求报文和响应报文\n点击"重试"可重新推送失败的记录',
          position: 'top'
        }
      }
    ]
  }
}

function createDriver() {
  return driver({
    showProgress: true,
    doneBtnText: '完成',
    nextBtnText: '下一步',
    prevBtnText: '上一步',
    closeBtnText: '跳过',
    stageBackground: '#ffffff',
    stagePadding: 8,
    popoverClass: 'coo-guide-popover'
  })
}

export function startGuide(name) {
  const config = guideConfig[name]
  if (!config) return
  const driverObj = createDriver()
  driverObj.setSteps(config.steps)
  driverObj.drive()
}

export function startGuideIfNeeded(name) {
  const key = `coo_guide_done_${name}`
  const done = localStorage.getItem(key)
  if (!done) {
    setTimeout(() => {
      startGuide(name)
      localStorage.setItem(key, '1')
    }, 800)
  }
}

export function resetAllGuides() {
  Object.keys(guideConfig).forEach(name => {
    localStorage.removeItem(`coo_guide_done_${name}`)
  })
}

export default { startGuide, startGuideIfNeeded, resetAllGuides }
